<template>
  <div class="all_body">
    <div class="buy_info">
      <div class="buy_info_body">
        <el-form ref="form" :model="form" :rules="rules">
          <div class="buy_info_content">
            <div class="buy_info_content_l font_bottom">购买版本：</div>
            <div class="buy_info_content_r">{{info.packagename}}</div>
          </div>
          <div class="buy_info_content">
            <div class="buy_info_content_l">订单编号：</div>
            <div>{{info.order_num}}</div>
          </div>
          <div class="buy_info_line"></div>
          <div class="buy_info_content">
            <div class="buy_info_content_l">集团全称：</div>
            <div>{{info.group_name}}</div>
          </div>
          <div class="buy_info_content">
            <div class="buy_info_content_l">联系人：</div>
            <div>{{info.user_name}}</div>
          </div>
          <div class="buy_info_content">
            <div class="buy_info_content_l">联系方式：</div>
            <div>{{info.phone}}</div>
          </div>
          <div class="buy_info_content">
            <div class="buy_info_content_l">地址信息：</div>
            <div>{{info.address}}</div>
          </div>
          <div class="buy_info_content">
            <div class="buy_info_content_l">有效期：</div>
            <div>{{info.duetime}}</div>
          </div>
          <div class="buy_info_line"></div>
          <div class="buy_info_content">
            <div class="buy_info_content_l">付款价格：</div>
            <div>￥{{info.payment_amount}}</div>
          </div>
          <div class="buy_info_content">
            <div class="buy_info_content_l">付款账户：</div>
            <div>{{info.order_type}}</div>
          </div>
          <div class="buy_info_content">
            <div class="buy_info_content_l font_bottom">付款方式：</div>
            <div>
              <el-form-item label prop="pay_type">
                <el-radio-group v-model="form.pay_type">
                  <el-radio label="1">
                    <div class="pay_type">
                      <div class="pay_type_wx">
                        <img :src="pay_wx" />
                      </div>微信支付
                    </div>
                  </el-radio>
                  <el-radio label="0">
                    <div class="pay_type pay_type_w">
                      <div class="pay_type_wx">
                        <img :src="pay_zhi" />
                      </div>支付宝支付
                    </div>
                  </el-radio>
                  <el-radio label="3">
                    <div class="pay_type">
                      <div class="pay_type_wx">
                        <img :src="pay" />
                      </div>网银支付
                    </div>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div class="buy_info_content">
            <div class="buy_info_content_l">汇款账户：</div>
            <div class="buy_info_content_2">
              开户行：{{info.account_bank}}
              <br />账户：{{info.account}}
              <br />
              <div class="buy_info_v">* 支付成功后，请凭支付凭证联系客服。</div>
            </div>
          </div>
          <div class="buy_info_line"></div>
          <div class="buy_info_content">
            <div class="buy_info_content_l font_bottom">客服电话：</div>
            <div class="buy_info_content_r">{{info.cus_phone}}</div>
          </div>
          <div class="buy_info_button">
            <div class="buy_info_button_cancel" @click="cancel">取消</div>
            <div class="buy_info_button_success" @click="submit">提交</div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { getDetailById,updateOrderStatus } from "../../api/api";
export default {
  name: "Buy_info",
  data() {
    return {
      pay: "./static/img/pay.png",
      pay_wx: "./static/img/pay_wx.png",
      pay_zhi: "./static/img/pay_zhi.png",
      id: "",
      form: {},
      info:{},
      rules: {
        pay_type: [
          { required: true, message: "付款方式不能为空", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    this.$store.commit("settab", 6);
    this.id = this.$route.params.id;
    this.getInfos(this.id);
  },
  methods: {
    getInfos(id) {
        console.log(localStorage.getItem('ticket'))
        getDetailById({
            ticket : localStorage.getItem('ticket'),
            id : id
        }).then(res => {
            this.info = res.data
            console.log(res)
        })
    },
    cancel(){
        this.$router.go(-1)
    },
    submit(){
        this.form.id = this.id ,
        this.form.ticket = localStorage.getItem('ticket'),
        this.$refs["form"].validate(valid => {
        if (valid) {
            updateOrderStatus(this.form).then(res => {
              if(res.code === "2000"){
                localStorage.setItem("breed", 1);
                  this.$router.push('/Buy_success')
                  return false;
              }else{
                this.$message.error(res.msg)
              }
            });
        }
      })
        
    }
  }
};
</script>
<style>
.all_body{
  width: 100%;
  padding-left: 11%;
  padding-right: 10%;
}
.buy_info {
  margin: 30px 0 50px 0;
  background: #eeeeee;
}
.buy_info_body {
  width: 1000px;
  margin: 0 auto;
  padding-top: 70px;
}
.buy_info_content {
  display: flex;
  font-size: 20px;
  color: #343434;
  margin-top: 26px;
}
.buy_info_content_l {
  width: 120px;
  text-align: right;
  margin-right: 20px;
}
.buy_info_content_r {
  width: 880px;
  font-size: 30px;
  color: #000000;
  float: left;
}
.buy_info_line {
  margin-top: 44px;
  width: 1000px;
  height: 1px;
  background: #aaaaaa;
}
.font_bottom {
  padding-top: 10px;
}
.buy_info_button {
  padding-bottom: 90px;
  margin-top: 60px;
  display: flex;
}
.buy_info_button_cancel {
  width: 300px;
  height: 44px;
  background: #cdcdcd;
  border-radius: 6px;
  font-size: 20px;
  line-height: 44px;
  text-align: center;
  color: #646464;
  cursor: pointer;
}
.buy_info_button_success {
  margin-left: 126px;
  width: 300px;
  height: 44px;
  background: #56b234;
  border-radius: 6px;
  font-size: 20px;
  line-height: 44px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}
.buy_info_v {
  padding-top: 20px;
  color: #ff0000;
}
.buy_info_content_2 {
  line-height: 35px;
}

.pay_type {
  width: 170px;
  height: 50px;
  background: #ffffff;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
}

.buy_info_content .el-radio-group {
  display: flex;
}
.buy_info_content .el-radio {
  display: flex;
}
.buy_info_content .el-radio__inner {
  width: 16px;
  height: 16px;
  margin-top: 17px;
}
.buy_info_content .el-radio__input.is-checked .el-radio__inner {
  border-color: #56b234;
  background: #56b234;
}
.buy_info_content .el-radio__input.is-checked + .el-radio__label {
  color: #606266;
}
.pay_type_wx {
  margin-right: 10px;
}
.pay_type_w {
  width: 160px;
}
</style>


// WEBPACK FOOTER //
// src/views/sys/buy_info.vue